import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { css } from '@emotion/core';
import { loadHomeProducts } from '../../../redux/modules/homeProducts';
import { loadSidebarPosts } from '../../../redux/modules/posts';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';
import ModuleHeroBanner from './HomeModules/ModuleHeroBanner';
import ModuleTagsDiscounts from './HomeModules/ModuleTagsDiscounts';
import ModuleBlogNewsletter from './HomeModules/ModuleBlogNewsletter';
import ModuleProductsCarousel from './HomeModules/ModuleProductsCarousel';
import ModuleBannerCarousel from './HomeModules/ModuleBannerCarousel';
import ModuleImageBanner from './HomeModules/ModuleImageBanner';
import ModuleCompanyWelcome from './HomeModules/ModuleCompanyWelcome';
import ModuleProductsCarouselByTag from './HomeModules/ModuleProductsCarouselByTag';
import FeedatyWidget from './FeedatyWidget/FeedatyWidget';
import ModuleCategoryMenuCards from './HomeModules/ModuleCategoryMenuCards';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4ViewItemList,
  ga4ViewPromotion,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxViewItemList,
  fkmxViewPromotions,
} from '../../shared/lib/farmakomMetrics';
import ModuleTagMenu from './HomeModules/ModuleTagMenu';
import ModuleBrandsCarousel from './HomeModules/ModuleBrandsCarousel';
import ModuleAboutUs from './HomeModules/ModuleAboutUs';
import ModuleSymptomsCarousel from './HomeModules/ModuleSymptomsCarousel';
import { getSHA256Hash } from '../../../utils/sha256';

class Home extends Component {
  componentDidMount() {
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    // CRITEO TAG
    if (this.props.hasCriteo) {
      iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('home');
    }

    if (this.props.hasGoogleAnalytics4Advanced) {
      // GA4 TRACK LIST
      this.ga4TrackItemsList();
      // GA4 TRACK PROMOTION
      this.ga4TrackPromotion();
    }

    if (this.props.hasFarmakomMetrics) {
      // FKMX TRACK LIST
      this.fkmxTrackItemsList();
      // FKMX TRACK PROMOTION
      this.fkmxTrackPromotion();
    }
  }

  componentDidUpdate(oldProps) {
    if (
      (oldProps.discounted || []).length !==
      (this.props.discounted || []).length
    ) {
      const section = {
        listInfo: {
          id: 'special_offers',
          name: 'Special Offers',
        },
        items: this.props.discounted,
      };
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if ((oldProps.latest || []).length !== (this.props.latest || []).length) {
      const section = {
        listInfo: {
          id: 'latest_products',
          name: 'Latest Products',
        },
        items: this.props.latest,
      };
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if (
      (oldProps.bestSellers || []).length !==
      (this.props.bestSellers || []).length
    ) {
      const section = {
        listInfo: {
          id: 'best_seller_products',
          name: 'Best Seller Products',
        },
        items: this.props.bestSellers,
      };
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewItemList(section.items, section.listInfo);
      }
      if (this.props.hasFarmakomMetrics) {
        fkmxViewItemList(section.items, section.listInfo);
      }
    }
    if ((oldProps.tags || []).length !== (this.props.tags || []).length) {
      this.props.tags.forEach(banner => {
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4ViewPromotion(banner);
        }
      });
      if (this.props.hasFarmakomMetrics) {
        fkmxViewPromotions(this.props.tags);
      }
    }
    if (
      (oldProps.tagsDiscounts || []).length !==
      (this.props.tagsDiscounts || []).length
    ) {
      this.props.tagsDiscounts.forEach(banner => {
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4ViewPromotion(banner);
        }
      });
      if (this.props.hasFarmakomMetrics) {
        fkmxViewPromotions(this.props.tagsDiscounts);
      }
    }
  }

  renderCriteoTag = () => {
    // <!-- Criteo Homepage Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';
    const criteo_homepage_tag = document.createElement('script');
    criteo_homepage_tag.type = 'text/javascript';
    criteo_homepage_tag.innerHTML = `
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
        { event: "setAccount", account: ${this.props.criteoAccountId}},
        { event: "setEmail", email: "${getSHA256Hash(
          email
        )}", hash_method: "sha256" },
        { event: "setSiteType", type: deviceType},
        { event: "setZipcode", zipcode: "${zipcode}" },
        { event: "viewHome"});
    `;
    setTimeout(() => {
      document.body.appendChild(criteo_homepage_tag);
    }, 200);
    // <!-- END Criteo Home Page Tag -->
  };

  ga4TrackItemsList = () => {
    const { discounted, latest, bestSellers } = this.props;
    const toTrack = [];
    if (!!(this.props.discounted || []).length) {
      toTrack.push({
        listInfo: {
          id: 'special_offers',
          name: 'Special Offers',
        },
        items: discounted,
      });
    }
    if (!!(this.props.latest || []).length) {
      toTrack.push({
        listInfo: {
          id: 'latest_products',
          name: 'Latest Products',
        },
        items: latest,
      });
    }
    if (!!(this.props.bestSellers || []).length) {
      toTrack.push({
        listInfo: {
          id: 'best_seller_products',
          name: 'Best Seller Products',
        },
        items: bestSellers,
      });
    }
    toTrack.forEach(section =>
      ga4ViewItemList(section.items, section.listInfo)
    );
  };

  ga4TrackPromotion = () => {
    const { tags, tagsDiscounts } = this.props;
    const toTrack = [...(tags || []), ...(tagsDiscounts || [])];
    toTrack.forEach(banner => ga4ViewPromotion(banner));
  };

  fkmxTrackItemsList = () => {
    const { discounted, latest, bestSellers } = this.props;
    const toTrack = [];
    if (!!(this.props.discounted || []).length) {
      toTrack.push({
        listInfo: {
          id: 'special_offers',
          name: 'Special Offers',
        },
        items: discounted,
      });
    }
    if (!!(this.props.latest || []).length) {
      toTrack.push({
        listInfo: {
          id: 'latest_products',
          name: 'Latest Products',
        },
        items: latest,
      });
    }
    if (!!(this.props.bestSellers || []).length) {
      toTrack.push({
        listInfo: {
          id: 'best_seller_products',
          name: 'Best Seller Products',
        },
        items: bestSellers,
      });
    }
    toTrack.forEach(section =>
      fkmxViewItemList(section.items, section.listInfo)
    );
  };

  fkmxTrackPromotion = () => {
    const { tags, tagsDiscounts } = this.props;
    fkmxViewPromotions(tags);
    fkmxViewPromotions(tagsDiscounts);
  };

  render() {
    const {
      discounted,
      latest,
      bestSellers,
      loading,
      home,
      siteName,
      siteUrl,
      logoImage,
      hasBlog,
      tagsDiscounts,
      posts,
      feedaty,
      primaryColor,
      secondaryColor,
      uiVariantBannerCarousel,
      hasGoogleAnalytics4Advanced,
      hasFarmakomMetrics,
      homePageConfiguration,
      sliderCircleArrowsBanner,
      sliderCircleArrowsProducts,
      sliderNavigationDots,
      sliderCircleArrowsMagazine,
      productsThumbnail,
      coloredBackgroundProducts,
      coloredBackgroundCircularCarousel,
      coloredBackgroundCircularCarouselSymptoms,
      sliderCircleArrowsSymptoms,
      brandImages,
      companyName,
      coloredBackgroundMagazine,
      navigationDotsMagazine,
      aboutUsDetails,
      companyWelcome,
      sliderCircleArrowsBrands,
      symptomsData,
      advImages,
      isMobile,
      datiFarmacia,
    } = this.props;

    const bottomSlides = [
      {
        id: 1,
        seoName: home.slider1Slide1SeoName,
        imgUrl: home.slider1Slide1Image,
        link: home.slider1Slide1Link,
      },
      {
        id: 2,
        seoName: home.slider1Slide2SeoName,
        imgUrl: home.slider1Slide2Image,
        link: home.slider1Slide2Link,
      },
      {
        id: 3,
        seoName: home.slider1Slide3SeoName,
        imgUrl: home.slider1Slide3Image,
        link: home.slider1Slide3Link,
      },
    ];

    const getHomeModuleByValue = (module, isConsentGiven) => {
      switch (module.moduleType) {
        case 'Hero_banner':
          return (
            <section>
              <ModuleHeroBanner
                isMobile={isMobile}
                datiFarmacia={datiFarmacia}
                heroBannerVersion={module.moduleVersion}
                home={home}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                sliderCircleArrowsBanner={sliderCircleArrowsBanner}
                sliderNavigationDots={sliderNavigationDots}
                homePageConfiguration={homePageConfiguration}
              />
            </section>
          );
        case 'Company_welcome':
          if (!companyWelcome) return null;
          return (
            <section className="home-module">
              <ModuleCompanyWelcome
                companyWelcomeVersion={module.moduleVersion}
                companyWelcome={companyWelcome}
                secondaryColor={secondaryColor}
                homePageConfiguration={homePageConfiguration}
              />
            </section>
          );
        case 'Tag_menu':
          if (!!isMobile) return;
          return (
            <section>
              <ModuleTagMenu
                tagMenuVersion={module.moduleVersion}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                companyWelcome={companyWelcome}
              />
            </section>
          );
        case 'Products_carousel':
          return (
            <section className="home-module">
              <ModuleProductsCarousel
                isMobile={isMobile}
                productsCarouselVersion={module.moduleVersion}
                productsCarouselTitle={module.content}
                selected={module.productType || 'bestSellers'}
                productsThumbnail={productsThumbnail}
                loading={loading}
                latest={latest || []}
                bestSellers={bestSellers || []}
                discounted={discounted || []}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                sliderCircleArrowsProducts={sliderCircleArrowsProducts}
                coloredBackgroundProducts={coloredBackgroundProducts}
                productsExplodedMobileView={true}
              />
            </section>
          );
        case 'Circular_carousel_brands':
          return (
            <section className="home-module">
              <ModuleBrandsCarousel
                isMobile={isMobile}
                circularCarouselVersion={module.moduleVersion}
                brandsCarouselTitle={module.content}
                circularCarouselImages={brandImages}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                coloredBackgroundCircularCarousel={
                  coloredBackgroundCircularCarousel
                }
                sliderCircleArrowsBrands={sliderCircleArrowsBrands}
              />
            </section>
          );
        case 'Discount_tags_carousel':
          return !!tagsDiscounts && tagsDiscounts.length > 0 ? (
            <section className="home-module">
              <ModuleTagsDiscounts
                isMobile={isMobile}
                discountTagsVersion={module.moduleVersion}
                tagsDiscounts={tagsDiscounts}
                home={home}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
                hasFarmakomMetrics={hasFarmakomMetrics}
              />
            </section>
          ) : null;
        case 'Blog_newsletter':
          return (
            <section className="home-module">
              <ModuleBlogNewsletter
                isMobile={isMobile}
                blogNewsletterVersion={module.moduleVersion}
                hasBlog={hasBlog}
                home={home}
                posts={posts}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                coloredBackgroundMagazine={coloredBackgroundMagazine}
                navigationDotsMagazine={navigationDotsMagazine}
                sliderCircleArrowsMagazine={sliderCircleArrowsMagazine}
              />
            </section>
          );
        case 'Category_tags_cards':
          return (
            <section className="home-module">
              <ModuleCategoryMenuCards
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
              />
            </section>
          );
        case 'Advertising_banner':
          return (
            <section className="home-module">
              <ModuleBannerCarousel
                isMobile={isMobile}
                advertisingBannerVersion={module.moduleVersion}
                slides={bottomSlides}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                uiVariantBannerCarousel={uiVariantBannerCarousel}
              />
            </section>
          );
        case 'Feedaty_banner':
          return !!feedaty.enabled && !!feedaty.merchantCode ? (
            <section className="feedaty-section">
              <FeedatyWidget
                feedaty={feedaty}
                hasIubendaCookieSolution={this.props.hasIubendaCookieSolution}
              />
            </section>
          ) : null;
        case 'About_us':
          return (
            <section className="home-module">
              <ModuleAboutUs
                isMobile={isMobile}
                aboutUsVersion={module.moduleVersion}
                aboutUsDetails={aboutUsDetails}
                companyName={companyName}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
              />
            </section>
          );
        case 'Image_banner':
          return (
            <section className="home-module">
              <ModuleImageBanner
                imageBannerVersion={module.moduleVersion}
                advImages={advImages}
                secondaryColor={secondaryColor}
              />
            </section>
          );
        case 'Products_carousel_by_tag':
          return (
            <section className="home-module">
              <ModuleProductsCarouselByTag
                productsThumbnail={productsThumbnail}
                productsCarouselVersion={module.productsRelatedToTagVersion}
                seoName={module.content}
                coloredBackgroundProducts={coloredBackgroundProducts}
                sliderCircleArrowsProducts={sliderCircleArrowsProducts}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
              />
            </section>
          );
        case 'Circular_carousel_symptoms':
          return (
            <section className="home-module">
              <ModuleSymptomsCarousel
                isMobile={isMobile}
                circularCarouselSymptomsVersion={module.moduleVersion}
                symptomsCarouselTitle={module.content}
                symptomsData={symptomsData}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                coloredBackgroundCircularCarouselSymptoms={
                  coloredBackgroundCircularCarouselSymptoms
                }
                sliderCircleArrowsSymptoms={sliderCircleArrowsSymptoms}
              />
            </section>
          );
        default:
          return null;
      }
    };

    const homeStyle = css`
      margin-top: 0%;
      overflow: hidden;

      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        gap: 2rem;
      }

      * {
        font-family: $font-family-dm-sans;
      }

      section {
        @media screen and (max-width: 768px) {
          margin: 0 !important;
          padding: 0 !important;
        }

        &.home-module {
          margin: 2rem 0;

          @media screen and (max-width: 992px) {
            margin: 1.5rem 0;
          }

          & .container,
          & .container-fluid {
            padding-right: 0px;
            padding-left: 0px;
          }
          & .container {
            @media (min-width 200px) {
              max-width: 94%;
            }
            @media (min-width: 768px) {
              max-width: 94%;
            }
            @media (min-width: 992px) {
              max-width: 94%;
            }
            @media (min-width: 1200px) {
              max-width: 94%;
            }
          }

          &.feedaty-section {
            padding: 0;
          }

          &:first-of-type {
            padding: 0 0 35px;
          }
        }
      }
    `;

    const sortedConfiguration = this.props.homePageConfiguration.sort(
      (a, b) => a.position - b.position
    );

    return (
      <>
        <main id="my-home" className="homepage" css={homeStyle}>
          <Helmet
            title="Home"
            meta={[
              {
                name: 'description',
                content: `${siteName} - Vendita on line di cosmetici, dietetici, integratori alimentari, prodotti per l'igiene, articoli sanitari ed elettromedicali`,
              },
              {
                name: 'keywords',
                content: `${siteName}, Farmacia, Farmacia on line, offerte, confronto prezzi, vendita cosmetici, vendita integratori, vendita elettromedicali, vendita articoli sanitari, vendita prodotti fitoterapici`,
              },
              {
                name: 'robots',
                content: 'index, follow',
              },
              {
                property: 'og:title',
                content: `${siteName} - Ecommerce Farmacia Online`,
              },
              { property: 'og:type', content: 'website' },
              {
                property: 'og:description',
                content: `Vendita on line di farmaci, cosmetici, dietetici, integratori alimentari, prodotti per l'igiene, articoli sanitari ed elettromedicali. Visita il nostro sito con elenco dinamico tag categorie`,
              },
              { property: 'og:image', content: logoImage },
            ]}
            link={[
              {
                rel: 'canonical',
                href: `${siteUrl}/`,
              },
            ]}
          ></Helmet>

          {sortedConfiguration.map(module => {
            return getHomeModuleByValue(module);
          })}
          <div className="push" />
        </main>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.data,
    isMobile: state.layout.isMobile,
    discounted: state.homeProducts.data.discounted,
    latest: state.homeProducts.data.recents,
    bestSellers: state.homeProducts.data.bestsellers,
    tags: state.homeProducts.data.tags,
    tagsDiscounts: state.homeProducts.data.tagsDiscounts,
    posts: state.posts.data.latest,
    loading: state.homeProducts.loading,
    home: state.store.data.home,
    datiFarmacia: state.store.data.datiFarmacia,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    logoImage: state.store.data.loghiTemplate.logoImage,
    hasBlog: state.store.data.features.hasBlog,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    feedaty: {
      enabled: state.store.data.features.hasFeedaty,
      merchantCode: state.store.data.integrazioni.feedaty.merchantCode,
      widgetId: state.store.data.integrazioni.feedaty.widgetId,
      siteKey: state.store.data.integrazioni.feedaty.siteKey,
    },
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantBannerCarousel: state.store.data.uiVariants.bannerCarousel,
    hasCriteo: state.store.data.features.hasCriteo,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    sliderCircleArrowsBanner:
      state.store.data.home.visualVariants.sliderCircleArrowsBanner,
    sliderCircleArrowsProducts:
      state.store.data.home.visualVariants.sliderCircleArrowsProducts,
    sliderCircleArrowsBrands:
      state.store.data.home.visualVariants.sliderCircleArrowsBrands,
    sliderCircleArrowsSymptoms:
      state.store.data.home.visualVariants.sliderCircleArrowsSymptoms,
    sliderCircleArrowsMagazine:
      state.store.data.home.visualVariants.sliderCircleArrowsMagazine,
    sliderNavigationDots:
      state.store.data.home.visualVariants.sliderNavigationDots,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
    coloredBackgroundProducts:
      state.store.data.home.visualVariants.backgroundVariationProducts,
    coloredBackgroundCircularCarousel:
      state.store.data.home.visualVariants.backgroundVariationCircularCarousel,
    coloredBackgroundCircularCarouselSymptoms:
      state.store.data.home.visualVariants
        .backgroundVariationCircularCarouselSymptoms,
    coloredBackgroundMagazine:
      state.store.data.home.visualVariants.backgroundVariationMagazine,
    brandImages: state.store.data.home.brandImages,
    companyName: state.store.data.datiFarmacia.companyName,
    navigationDotsMagazine:
      state.store.data.home.visualVariants.sliderNavigationDotsMagazine,
    aboutUsDetails: state.store.data.home.aboutUsDetails,
    companyWelcome: state.store.data.home.companyWelcome,
    products: state.products.data,
    symptomsData: state.store.data.home.symptomsData,
    advImages: state.store.data.home.advImages,
    productsExplodedMobileView:
      state.store.data.home.visualVariants.mobileProductsExplodedView,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Home, [loadHomeProducts, loadSidebarPosts])
);
